import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import WhyAfrica from './pages/WhyAfrica';
import Partners from './pages/Partners';
import About from './pages/About';
import Ecosystem from './pages/Ecosystem';
import Opportunity from './pages/Opportunity';
import Invest from './pages/Invest';
import Team from './pages/Team';
import Sankofa from './pages/Sankofa';
import ClimateImpact from './pages/ClimateImpact';
import Tokenomics from './pages/Tokenomics';
import TermsConditions from './pages/TermsConditions';
import FAQ from './pages/FAQ';
import News from './pages/News';
import BlogDetail from './pages/BlogDetail';
import './index.css';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Azura Mobility | Powering Africa\'s Electric Future',
  '/why-africa': 'Why Africa | Azura Mobility',
  '/partners': 'Partners | Azura Mobility',
  '/about': 'About Us | Azura Mobility',
  '/ecosystem': 'Ecosystem | Azura Mobility',
  '/opportunity': 'The Opportunity | Azura Mobility',
  '/invest': 'Invest | Azura Mobility',
  '/team': 'Our Team | Azura Mobility',
  '/climate-impact': 'Climate Impact | Azura Mobility',
  '/sankofa': 'Sankofa | Azura Mobility',
  '/tokenomics': 'Tokenomics | Azura Mobility',
  '/terms': 'Terms & Conditions | Azura Mobility',
  '/faq': 'FAQ | Azura Mobility',
  '/news': 'News | Azura Mobility',
};

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = PAGE_TITLES[pathname] ?? 'Azura Mobility';
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/why-africa" element={<WhyAfrica />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/about" element={<About />} />
            <Route path="/ecosystem" element={<Ecosystem />} />
            <Route path="/opportunity" element={<Opportunity />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/team" element={<Team />} />
            <Route path="/climate-impact" element={<ClimateImpact />} />
            <Route path="/sankofa" element={<Sankofa />} />
            <Route path="/tokenomics" element={<Tokenomics />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<BlogDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
